// how an NWS alert surfaces (config/clock.json `advisories`, decided Oct 26): 'quiet' events are only a tag on their
// own screen ('bay' for Bay & Tides, 'crab' for the Crab Report), 'ignore' events show nowhere, the rest ('crawl') keep
// ws4kp's Hazards screen and crawl and our ticker. Warnings that interrupt are interrupt.mjs's business.
// ws4kp's hazards.mjs reads window.RHL.hiddenHazards (upstream patch 5) to leave quiet and ignored events out.
import { time, weekday, isToday } from './format.mjs';

const { clock } = window.RHL;
const { quiet = {}, ignore = [] } = clock.advisories ?? {};

window.RHL.hiddenHazards = [...Object.keys(quiet), ...ignore];

const tierOf = (event = '') => {
	if (ignore.includes(event)) return 'ignore';
	return quiet[event] ?? 'crawl';
};

// A beach alert said in its own words (Nov 1, Jared: "Beach Hazards Statement" with no detail, a day before it began).
// The NWS issues these ahead of time, so `onset` matters: before it the alert is a heads-up ("from MON 5 AM"), after
// it a fact ("until TUE 8 PM"). What it warns of comes from the description's WHAT line (the sidecar's `summary`).
export const SURF_ZONE = 'CAZ509';
const DANGERS = [
	// the NWS wraps its text at a fixed width, so a line break can fall inside a phrase ("rip\ncurrents")
	[/sneaker\s+wave/i, 'sneaker waves'],
	[/rip\s+current/i, 'rip currents'],
	[/high\s+surf/i, 'high surf'],
	[/large\s+breaking\s+wave/i, 'large breaking waves'],
	[/coastal\s+flood/i, 'coastal flooding'],
];
const at = (t, now) => `${isToday(t, now) ? '' : `${weekday(t)} `}${time(t)}`;
export const inEffect = (alert, now = new Date()) => !alert.onset || new Date(alert.onset) <= now;
export const ended = (alert, now = new Date()) => alert.ends && new Date(alert.ends) <= now;
export const beachAlert = (alerts, now = new Date()) => (alerts ?? [])
	.find((a) => a.zones?.includes(SURF_ZONE) && /rip|surf|beach|sneaker/i.test(a.event) && !ended(a, now));
// "Sneaker waves, rip currents" (or the event's name when the text names none of these)
export const dangers = (alert) => {
	const text = `${alert.event} ${alert.summary ?? ''}`;
	const found = DANGERS.filter(([re]) => re.test(text)).map(([, words]) => words);
	if (!found.length) return alert.event;
	const list = found.join(', ');
	return list[0].toUpperCase() + list.slice(1);
};
// "from MON 5 AM" before it begins, "until TUE 8 PM" while it runs
export const alertWhen = (alert, now = new Date()) => {
	if (!inEffect(alert, now)) return `from ${at(alert.onset, now)}`;
	return alert.ends ? `until ${at(alert.ends, now)}` : '';
};

export default tierOf;
